<template>
	<div>
		<v-btn x-small icon v-if="focuses.length > 1" @click="changeFocus"><v-icon v-text="icon" x-small class="mr-2"></v-icon></v-btn>
		<v-select v-model="style" :items="classes"></v-select>		
	</div>
		
</template>

<script>
	export default {
		name: "EditorTypography",
		props:["values"],
		data: () => {
			return {
				style: "",
				focus: "",
				classes: ["mw-h0", "mw-h1", "mw-h2", "mw-h3", "text-large", "text", "text-small"],
			}
		},
		computed: {
			icon(){
				if( this.focus == "title" ){
					return "mdi-format-title"
				}
				return "mdi-format-text-variant"
			},
			focuses() {
				return Object.keys(this.values);
			},
		}, 
		watch: {
			focus: {
				immediate: true, 
				handler(){
					this.style = this.values[this.focus]
				}
			},
			style (){
				this.$emit("change", this.style, this.focus)
			}
		},
		methods: {
			changeFocus(){
				var i = this.focuses.indexOf( this.focus ) 
				i++;
				if( i == this.focuses.length ){
					i = 0;
				}
				this.focus = this.focuses[i]
			},

		}, 
		created(){
			this.focus = Object.keys(this.values)[0]
		}
	}
</script>